(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-mv-stories]').forEach(function (section) {
      if (section.dataset.mvReady) return;
      section.dataset.mvReady = 'true';
      var track = section.querySelector('.mv-stories__track');
      var slides = section.querySelectorAll('.mv-story');
      var dots = section.querySelectorAll('[data-mv-slide]');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth'});
        });
      });
      var scheduled = false;
      track.addEventListener('scroll', function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          var nearest = 0, distance = Infinity;
          slides.forEach(function (slide, index) {
            var value = Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left);
            if (value < distance) {distance = value; nearest = index;}
          });
          dots.forEach(function (dot, index) {
            dot.classList.toggle('is-current', index === nearest);
            if (index === nearest) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        });
      }, {passive: true});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) {init(event.target);});
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('.mv-story');
    if (!slide) return;
    var track = slide.parentElement;
    track.scrollTo({left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'auto'});
  });
})();
